import React, { useState } from 'react';
import { ChatBubbleOvalLeftIcon } from '@heroicons/react/24/outline';
import NoteModal from '../../../modals/NoteModal';
import { useDispatch } from 'react-redux';
import { createNote, updateNote } from '../../../store/thunks/notesThunk';

function ClinicianInfo({ clinician, dailyNote, calendarDate, onNoteUpdate, onNoteDelete, showAllClinics, clinicianClinic, allClinics }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [noteText, setNoteText] = useState(dailyNote);

  const getBgColor = () => {
    if (clinician.specialization && clinician.specialization.length > 0) {
      switch (clinician.specialization[0]) {
        case "SLP":
          return "bg-blue-100";
        case "CDA":
          return "bg-green-100";
        default:
          return "bg-gray-100";
      }
    }
    return "bg-gray-100";
  };

  const getClinicName = () => {
    if (!showAllClinics || !clinicianClinic || !allClinics) return null;
    const clinic = allClinics.find(c => c._id === clinicianClinic);
    return clinic ? clinic.name : null;
  };

  const getClinicColor = () => {
    if (!showAllClinics || !clinicianClinic || !allClinics) return null;
    const colors = [
      'bg-red-100 text-red-800',
      'bg-blue-100 text-blue-800', 
      'bg-green-100 text-green-800',
      'bg-yellow-100 text-yellow-800',
      'bg-purple-100 text-purple-800',
      'bg-pink-100 text-pink-800',
      'bg-indigo-100 text-indigo-800'
    ];
    const index = allClinics.findIndex(c => c._id === clinicianClinic);
    return colors[index % colors.length] || 'bg-gray-100 text-gray-800';
  };

  const handleNoteClick = () => {
    setNoteText(dailyNote); // Set the current note text
    setIsModalOpen(true); // Open the modal
  };

  return (
    <div className={`flex flex-col items-center justify-center w-full p-2 border-b border-gray-200 border-l-2 ${getBgColor()}`}>
      <h2 className="text-lg font-semibold">{clinician.firstName} {clinician.lastName}</h2>
      <p className="text-sm text-gray-500">{clinician.qualifications || clinician.credentials || "Clinician"}</p>
      
      {/* Clinic Badge when showing all clinics */}
      {showAllClinics && getClinicName() && (
        <div className={`mt-1 px-2 py-1 rounded-full text-xs font-medium ${getClinicColor()}`}>
          {getClinicName()}
        </div>
      )}

      {/* Speech Bubble */}
      <div 
        className="absolute top-2 right-2 cursor-pointer z-100"
        onClick={handleNoteClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <ChatBubbleOvalLeftIcon 
          className={`h-6 w-6 ${dailyNote ? 'text-white' : 'text-gray-600'}`} 
          style={{
            fill: dailyNote ? 'rgb(239, 68, 68)' : 'transparent',
            stroke: dailyNote ? 'rgb(239, 68, 68)' : 'currentColor'
          }}
        />
      </div>

      {/* Dialogue Box */}
      {isHovered && dailyNote && (
        <div className="absolute top-10 right-2 bg-white border border-gray-300 rounded shadow-md p-2">
          <pre className="text-sm text-gray-800 whitespace-pre-wrap">{dailyNote.content}</pre>
        </div>
      )}

      {/* Note Modal */}
      {isModalOpen && (
        <NoteModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          dailyNote={dailyNote}
          onSave={onNoteUpdate}
          onDelete={onNoteDelete}
          clinician={clinician}
          calendarDate={calendarDate}
        />
      )}
    </div>
  );
}

export default ClinicianInfo